export default "__VITE_ASSET__up6irO7C__"